import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AvailabilityTypePageConfig } from '../models/checkout-journey.types';
import { BasketStore } from '@features/basket/stores/basket.store';

export const REQUEST_AVAILABILITY_TYPE_CONFIG: AvailabilityTypePageConfig[] = [
  {
    pageRoute: 'addons',
    zoneConfig: {
      actions: [
        {
          id: 'next',
          buttonLabel: 'Videre',
          action: 'next',
          disabled: () => false,
        },
      ],
    },
  },
  {
    pageRoute: 'personal-info',
    zoneConfig: {
      actions: [
        {
          id: 'next',
          buttonLabel: 'Send forespørgsel',
          action: 'next',
        },
      ],
    },
  },
  {
    pageRoute: 'complete',
    zoneConfig: {
      actions: [
        {
          id: 'primary-action',
          buttonLabel: 'Se mine bookinger',
          buttonType: 'filled',
          action: 'custom',
          callback: async () => {
            const basketStore = inject(BasketStore);
            const router = inject(Router);
            basketStore.clearBasket();
            await router.navigate(['/account/bookings']);
          },
        },
        {
          id: 'secondary-action',
          buttonLabel: 'Søg efter nye tider',
          buttonType: 'outlined',
          action: 'custom',
          callback: async () => {
            const router = inject(Router);
            await router.navigate(['/search']);
          },
        },
      ],
    },
  },
];
